@app.controller 'ComponentsIndexController', (ComponentService) ->
  @index = []

  ComponentService.index ((components) =>
    @index = components
  ), (error) ->
    console.log 'Error while getting components: ', error

  this
